module.exports = __webpack_public_path__ + "static/media/direction.9876f79e.svg";